import { defineMessages } from 'react-intl';

export const roleStepMessages = defineMessages({
  tellUsAboutYourRole: {
    defaultMessage: 'Tell us about your role',
    id: '7lxkBdjSfs',
    description: 'Title of the onboarding role/personalization step',
  },
  roleSubtitle: {
    defaultMessage: "We'll tailor Heidi to your work",
    id: 'RNo8e2nUlx',
    description: 'Subtitle of the onboarding role/personalization step',
  },
  specialty: {
    defaultMessage: 'Specialty',
    id: '4UvBuQo1vW',
    description: 'Label for the specialty picker on the role step',
  },
  role: {
    defaultMessage: 'Role',
    id: 'zLMkTuqd/g',
    description: 'Label for the organisation role select on the role step',
  },
  selectRole: {
    defaultMessage: 'Select role',
    id: 'ANEaMQrX60',
    description: 'Placeholder for the organisation role select on the role step',
  },
  country: {
    defaultMessage: 'Country',
    id: 'rBGgD+be0y',
    description: 'Label for the country select on the role step',
  },
  displayLanguage: {
    defaultMessage: 'Language',
    id: '4MAjdg9HHf',
    description: 'Label for the display language select on the role step',
  },
  selectDisplayLanguage: {
    defaultMessage: 'Select a language',
    id: 'UCjAPOHf25',
    description: 'Placeholder for the display language select on the role step',
  },
  continue: {
    defaultMessage: 'Continue',
    id: 'YxxRyCZfbK',
    description: 'Submit button on the onboarding role/personalization step',
  },
  phoneNumber: {
    defaultMessage: 'Phone number',
    id: 'p0/4wG4jLw',
    description:
      'Label for the required phone number field on the role/personalization step',
  },
  phoneNumberOptional: {
    defaultMessage: 'Phone number (optional)',
    id: 'rIaVZRIm3d',
    description:
      'Label for the optional phone number field on the role/personalization step',
  },
  phoneNumberPlaceholder: {
    defaultMessage: 'Enter a phone number',
    id: 'wzT3BeYx9c',
    description:
      'Placeholder for the phone number input on the role/personalization step',
  },
  countryPhoneMismatchWarning: {
    defaultMessage:
      "The phone number country code doesn't match your selected country. Please verify this is correct.",
    id: '7SHpb3XyTc',
    description:
      'Warning shown when the entered phone number country code does not match the selected country',
  },
});
